export enum CurrencyEnum {
  CAD = 'CAD',
  EUR = 'EUR',
  GBP = 'GBP',
  USD = 'USD',
}
